import { Box, InputLabel, TextField } from '@mui/material';
import { Controller, FieldValues, useWatch } from 'react-hook-form';

import { BaseInputProps } from './GetFormInput';

export function FormInput<T extends FieldValues>({
    control,
    dependentField,
    disabled,
    fullWidth,
    helperText,
    label,
    multiline,
    required,
    small,
    validation,
    value,
}: Readonly<BaseInputProps<T>>) {
    const dependentFieldValue = useWatch({ control, name: dependentField ?? '' });
    const isDisabled = dependentField ? !dependentFieldValue : false;

    return (
        <Controller
            control={control}
            disabled={isDisabled}
            name={value}
            render={({ field: { onBlur, onChange, ref, value }, fieldState: { error } }) => (
                <Box>
                    <InputLabel sx={{ color: 'black', fontWeight: 'medium', mb: 0.5 }}>{label}</InputLabel>
                    <TextField
                        disabled={disabled ? disabled : isDisabled}
                        error={error?.message ? true : false}
                        fullWidth
                        helperText={error?.message ?? helperText}
                        multiline={multiline}
                        onBlur={onBlur}
                        onChange={onChange}
                        ref={ref}
                        required={required}
                        size={small ? 'small' : 'medium'}
                        sx={{ maxWidth: fullWidth ? undefined : 350 }}
                        value={value as string}
                        variant="outlined"
                    />
                </Box>
            )}
            rules={{
                required: required ? `${label ?? value} cannot be empty` : false,
                validate: (value) => {
                    if (value) {
                        const result = validation?.safeParse(value);
                        return result?.success ? true : result?.error.errors[0]?.message;
                    }
                },
            }}
        />
    );
}
